import { render } from "./BetanoMag.vue?vue&type=template&id=488d81d9&scoped=true"
import script from "./BetanoMag.vue?vue&type=script&lang=js"
export * from "./BetanoMag.vue?vue&type=script&lang=js"

import "./BetanoMag.vue?vue&type=style&index=0&id=488d81d9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488d81d9"]])

export default __exports__